import regionSettingsMessages from
  'ringcentral-integration/modules/RegionSettings/regionSettingsMessages';

export default {
  region: 'Región',
  [regionSettingsMessages.saveSuccess]: 'La configuración se guardó correctamente.',
  [regionSettingsMessages.dialingPlansChanged]: 'Su cuenta ya no se admite para su cuenta.\n    Verifique su nueva {regionSettingsLink}.',
  regionSettings: 'configuración de región',
  [regionSettingsMessages.areaCodeInvalid]: 'Ingrese un código de área válido.',
};
